<script setup lang="ts">
import { WhatsappIcon } from 'assets/data/icons';
const Icon = useIcon();
</script>
<template>
  <Icon :path="WhatsappIcon" :size="28" class="mb-1 mr-0.5" filled />
</template>
